<template>
  <v-card class="align-center justify-end" outlined>
    <v-card-title class="d-flex align-center justify-end" v-if="hasCloseWindowAction">
      <v-icon class="icon" @click="closeWindow">fa-times</v-icon>
    </v-card-title>
    <v-card-text class="pa-7">
      <div class="d-flex justify-center">
        <v-img class="mb-3" position="center center" src="https://hub.swiset.com/wp-content/uploads/2021/02/Swiset-Pro-Feature.png" max-width="77px" contain/>
      </div>
      <h2 class="text-center">{{ $t('title_UnavailableFeature') }}</h2>
      <p class="text-center" v-html="$t('description_UnavailableFeature')"/>
      <v-btn class="button-convert" style="width: 100%" @click="goToPro">
        {{ plan == 'Free' || plan == 'Gratis' ? $t('btnSeeBenefits') : $t('btnContactSupport') }} »</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "UnavailableFeature",
  props: {
    hasCloseWindowAction: Boolean,
  },
  data() {
    return {
      plan: this.$store.state.clubMember.club.clubPackage.name,
    }
  },
  methods: {
    goToPro() {
      if(this.plan == 'Swiset custom') {
        window.open("https://t.me/Swiset", '_blank');
      } else {
        this.$router.push('/subscription-plans-club')
      }
    },
    closeWindow() {
      this.$emit('closeWindow');
    },
  }
}
</script>



<style scoped>
.button-convert {
  background-color: #111111 !important;
  color: #ffffff !important;
  border: #111111 solid 1px;
}
</style>
